import { createFileRoute } from "@tanstack/react-router";

import { ServicePageLayout } from "../components/site/ServicePageLayout";
import { SITE_URL, breadcrumbJsonLd, buildMeta } from "../lib/site";
import { crumbTuples } from "../lib/breadcrumbs";
import { privacySections } from "../content/privacy";

const title = "Политика конфиденциальности — hay.agency";
const description =
  "Как hay.agency обрабатывает и защищает персональные данные пользователей сайта.";

export const Route = createFileRoute("/privacy")({
  head: () => ({
    ...buildMeta({
      title,
      description,
      path: "/privacy",
      image: `${SITE_URL}/og/default.webp`,
      imageWidth: 1200,
      imageHeight: 630,
      imageAlt: "hay.agency",
      locale: "ru_RU",
    }),
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@graph": [
            {
              "@type": "WebPage",
              "@id": `${SITE_URL}/privacy#webpage`,
              url: `${SITE_URL}/privacy`,
              name: title,
              description,
              isPartOf: { "@id": `${SITE_URL}/#website` },
              publisher: { "@id": `${SITE_URL}/#organization` },
            },
            breadcrumbJsonLd(crumbTuples("/privacy"), { inGraph: true }),
          ],
        }),
      },
    ],
  }),
  component: Page,
});

function Page() {
  return (
    <ServicePageLayout breadcrumb="Политика конфиденциальности" jsonLd={false}>
      <section className="mx-auto w-full max-w-[820px] px-5 pb-16 pt-8 lg:pb-24 lg:pt-12">
        <h1 className="text-[32px] font-medium leading-[36px] tracking-[-0.02em] lg:text-[44px] lg:leading-[48px]">
          Политика конфиденциальности
        </h1>
        <p className="mt-3 text-[13px] leading-[18px] text-muted-foreground">
          (действует с 1 января 2026 года)
        </p>

        <div className="mt-10 space-y-10 lg:mt-14">
          {privacySections.map((section) => (
            <section key={section.title}>
              <h2 className="text-[13px] font-medium uppercase leading-[18px] tracking-[0.08em] text-foreground">
                {section.title}
              </h2>
              <div className="mt-4 space-y-3">
                {section.items.map((item) => (
                  <p
                    key={item.slice(0, 60)}
                    className="text-[14px] leading-[22px] text-muted-foreground"
                  >
                    {item}
                  </p>
                ))}
              </div>
            </section>
          ))}
        </div>

        <div className="mt-14 border-t border-border pt-6 text-[13px] leading-[18px] text-muted-foreground">
          Вопросы по обработке персональных данных:{" "}
          <a
            href="mailto:info@hay.agency"
            className="text-foreground underline underline-offset-4"
          >
            info@hay.agency
          </a>
        </div>
      </section>
    </ServicePageLayout>
  );
}
